import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@mui/material';

import './styles.scss';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  description?: string;
  cancelLabel: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmModal = ({
  open,
  title,
  description,
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
}: ConfirmModalProps) => {
  return (
    <Modal open={open} onClose={onCancel}>
      <div className="confirm-modal-container">
        <div className="confirm-modal-content">
          <div className="header">
            <h1>{title}</h1>
            <Button className="close-button" onClick={onCancel}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>
          {description && <p className="description">{description}</p>}
          <div className="buttons">
            <Button className="cancel-button" onClick={onCancel}>
              {cancelLabel}
            </Button>
            <Button
              className="confirm-button"
              onClick={() => {
                onConfirm();
                onCancel();
              }}
            >
              {confirmLabel}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
